import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["inert"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["flex flex-col gap-1 w-full p-1", { 'opacity-50': $setup.props.disabled }]),
        inert: $setup.props.disabled
    }, [
        ($setup.props.label || _ctx.$slots.label)
            ? (_openBlock(), _createBlock($setup["Label"], {
                key: 0,
                for: $setup.props.staticId?.toString(),
                disabled: $setup.props.disabled
            }, {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "label", {}, () => [
                        _createTextVNode(_toDisplayString($setup.labelComputed), 1 /* TEXT */)
                    ])
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["for", "disabled"]))
            : _createCommentVNode("v-if", true),
        _createVNode($setup["SelectRoot"], {
            "model-value": $setup.model,
            disabled: $setup.props.disabled || $setup.props.readonly,
            multiple: $setup.props.multiple,
            open: $setup.isOpen,
            "onUpdate:open": $setup.handleOpenChange,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ($setup.onUpdateModelValue($event)))
        }, {
            default: _withCtx(() => [
                _createVNode($setup["SelectTrigger"], {
                    id: $setup.props.staticId?.toString(),
                    class: _normalizeClass({ 'border-destructive ring-[0.5px] ring-destructive': $setup.hasErrors })
                }, _createSlots({
                    default: _withCtx(() => [
                        ($setup.selectedTitle)
                            ? (_openBlock(), _createBlock($setup["SelectValue"], {
                                key: 0,
                                placeholder: $setup.props.placeholder || _ctx.t('common.selectPlaceholder')
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($setup.selectedTitle), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["placeholder"]))
                            : (_openBlock(), _createBlock($setup["SelectValue"], {
                                key: 1,
                                placeholder: $setup.props.placeholder || _ctx.t('common.selectPlaceholder')
                            }, null, 8 /* PROPS */, ["placeholder"]))
                    ]),
                    _: 2 /* DYNAMIC */
                }, [
                    ($setup.props.clearable && $setup.hasValue)
                        ? {
                            name: "actions",
                            fn: _withCtx(() => [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "shrink-0 flex items-center justify-center rounded p-0.5 text-muted-foreground hover:text-foreground hover:bg-accent transition-colors",
                                    onPointerdown: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"])),
                                    onClick: _withModifiers($setup.clearValue, ["stop"])
                                }, [
                                    _createVNode($setup["CloseIcon"], { size: 14 })
                                ], 32 /* NEED_HYDRATION */)
                            ]),
                            key: "0"
                        }
                        : undefined
                ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "class"]),
                _createVNode($setup["SelectContent"], null, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.normalizedItems, (item, idx) => {
                            return (_openBlock(), _createBlock($setup["SelectItem"], {
                                key: item[$setup.valueKey] ?? idx,
                                value: item[$setup.valueKey],
                                disabled: item.disabled,
                                class: "group relative flex cursor-pointer select-none items-center gap-2 rounded px-2 py-1.5 text-sm outline-none data-highlighted:bg-accent data-highlighted:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50"
                            }, {
                                default: _withCtx(() => [
                                    ($setup.props.multiple)
                                        ? (_openBlock(), _createBlock($setup["EnCheckbox"], {
                                            key: 0,
                                            "model-value": $setup.isItemSelected(item),
                                            class: "pointer-events-none shrink-0"
                                        }, null, 8 /* PROPS */, ["model-value"]))
                                        : _createCommentVNode("v-if", true),
                                    _createVNode($setup["SelectItemText"], null, {
                                        default: _withCtx(() => [
                                            _renderSlot(_ctx.$slots, "item", { item: item }, () => [
                                                _createTextVNode(_toDisplayString(item[$setup.titleKey]), 1 /* TEXT */)
                                            ])
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */),
                                    (!$setup.props.multiple)
                                        ? (_openBlock(), _createBlock($setup["SelectItemIndicator"], {
                                            key: 1,
                                            class: "ml-auto"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode($setup["CheckIcon"], { size: 14 })
                                            ]),
                                            _: 1 /* STABLE */
                                        }))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "disabled"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 3 /* FORWARDED */
                })
            ]),
            _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["model-value", "disabled", "multiple", "open"]),
        _withDirectives(_createElementVNode("p", {
            class: _normalizeClass(["text-xs", $setup.errorMessage ? 'text-destructive' : 'text-muted-foreground'])
        }, _toDisplayString($setup.errorMessage || $props.hint), 3 /* TEXT, CLASS */), [
            [_vShow, $setup.errorMessage || $setup.showHint]
        ])
    ], 10 /* CLASS, PROPS */, _hoisted_1));
}
